import { render, staticRenderFns } from "./SMSTemplateManagement.vue?vue&type=template&id=5b66c460&scoped=true"
import script from "./SMSTemplateManagement.vue?vue&type=script&lang=js"
export * from "./SMSTemplateManagement.vue?vue&type=script&lang=js"
import style0 from "./SMSTemplateManagement.vue?vue&type=style&index=0&id=5b66c460&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b66c460",
  null
  
)

export default component.exports